<template>
  <el-dialog
    :visible.sync="assistantVisible"
    title="项目权限"
    class="assistant-permission-dialog"
    width="560px"
    @close="resetForm"
  >
    <permission-config-panel v-model="permissionData" :show-description="true" label-width="110px" />
    <span slot="footer" class="assistant-dialog-footer">
      <el-button type="text" class="cancel-btn" @click="assistantVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getFormPermission, saveFormPermission } from '@/api/project/form'
import PermissionConfigPanel from './permission-config-panel.vue'

export default {
  components: {
    PermissionConfigPanel
  },
  data() {
    return {
      assistantVisible: false,
      formKey: '',
      submitLoading: false,
      permissionData: {}
    }
  },
  mounted() {
    this.resetForm()
  },
  methods: {
    async open(formKey) {
      this.resetForm()
      this.assistantVisible = true
      await this.getChooseAssistant(formKey)
    },
    async getChooseAssistant(formKey) {
      const { data } = await getFormPermission(formKey)
      this.formKey = formKey
      this.permissionData = {
        editPermissionMode: data?.editPermissionMode || 'VIEW_BASED',
        assistants: data?.assistants || [],
        editors: data?.editors || []
      }
    },
    async handleSubmit() {
      this.submitLoading = true
      try {
        await saveFormPermission(this.formKey, {
          assistantUserIds: this.permissionData.assistants.map((item) => item.userId),
          editPermissionMode: this.permissionData.editPermissionMode,
          editorUserIds: this.permissionData.editors.map((item) => item.userId)
        })
        this.$message.success('保存成功')
        this.assistantVisible = false
        this.$emit('saved')
      } finally {
        this.submitLoading = false
      }
    },
    resetForm() {
      this.formKey = ''
      this.submitLoading = false
      this.permissionData = {
        editPermissionMode: 'VIEW_BASED',
        assistants: [],
        editors: []
      }
    }
  }
}
</script>

<style lang="scss">
.assistant-permission-dialog {
  .el-dialog__body {
    padding: 16px 24px 8px;
  }

  .assistant-dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 24px;
    padding-bottom: 8px;

    .cancel-btn {
      color: #00a3ff;
      padding: 0;

      &:hover,
      &:focus {
        color: #33b5ff;
      }
    }

    .el-button--primary {
      background-color: #00a3ff;
      border-color: #00a3ff;
      border-radius: 4px;
      min-width: 88px;

      &:hover,
      &:focus {
        background-color: #33b5ff;
        border-color: #33b5ff;
      }
    }
  }
}
</style>
